import { Button } from '@mui/material'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import CONFIG from '../../config'
import { Context } from '../../contexts/Context'

const style = { background: '#DAEAF1', padding: '10px', display: 'flex', justifyContent: 'center', gap: '20vw', position: 'fixed', top: '0', width: '100vw', zIndex: 101 }

export default function Header ({ token }) {
  const { handleToken } = useContext(Context)
  const navigate = useNavigate()
  const handleLogin = () => {
    handleToken(null)
    navigate('/login')
  }

  return (
    <>
      <div style={style}>
        <img onClick={() => navigate('/centers')} width='150px' style={{ cursor: 'pointer' }} src={CONFIG.tricog_logo} alt='Tricog' />
        {token && <Button sx={{ color: 'black', p: '2px 6px' }} variant='outlined' onClick={() => handleLogin()}>Logout</Button>}
      </div>
      <div style={{ marginTop: '75px' }} />
    </>
  )
}
